<template>
  <div id="topbar">
    <div class="top-nav1">
    <div class="w1230">
    <div class="headTopLeft">
    <div class="headTopLogoDiv">
    <img  src="../../assets/headTopLogo.png" class="headTopLogo" @click="goHomeUrl()"/>
    </div>
    <div class="headLine mt5"></div>
    <div class="mt5 headTitle">科技成果转化双推双促工程“新动能科技成果”申报系统</div>
    </div>
    <div class="headTopRight">
            <div v-if="hasToken" >
          <el-dropdown  @command="(command) => handleTableCommand(command)">
      <span class="el-dropdown-link">
        {{ userInfo.user_name ?? '用户' }}，您好<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
        <el-dropdown-item command="userCenter">个人中心</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

      </div>
      <div v-else class="el-dropdown-link" @click="goLogin">欢迎您，请登录</div>
    </div>
    </div>


      <!-- logo -->
      <!-- <div class="container"> -->
        <!-- <div class="containerTop">
          <div class="containerTopContent">
        <div v-if="hasToken">
          <el-dropdown  @command="(command) => handleTableCommand(command)">
      <span class="el-dropdown-link">
        {{ userInfo.user_name ?? '用户' }}，您好<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
        <el-dropdown-item command="userCenter">个人中心</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

      </div>
      <div v-else class="el-dropdown-link" @click="goLogin">欢迎您，请登录</div>
          </div>
        </div> -->

        <!-- <div class="leftHead">
          <a href="/">
            <img class="logo" src="../../assets/logo.png" alt="logo" />
          </a>
          <span class="line"></span>
          <span class="title">科技成果转化双推双促工程“新动能科技成果”申报系统</span>
        </div>
        <div class="rightHead">
          <div class="button" @click="goLogin">
            <span>登</span><span style="margin-left: 5px;">录</span>
          </div>
        </div> -->
      <!-- </div> -->
      <!-- <div class="homeTitleContainer">
        <div class="logoRight">
          <div class="homeTitleLeft"></div>
          <div class="homeTitleCenter">
            <img
              src="../../assets/logo.png"
              @click="goHomeUrl()"
              alt=""
              class="logo"
            />
          </div>
          <div class="homeTitleRight">
            <div v-if="hasToken">
              <el-dropdown @command="(command) => handleTableCommand(command)">
                <span class="el-dropdown-link">
                  {{ userInfo.name ?? "用户" }}，您好<i
                    class="el-icon-arrow-down el-icon--right"
                  ></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="loginOut"
                    >退出登录</el-dropdown-item
                  >
                  <el-dropdown-item command="userCenter"
                    >个人中心</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div v-else class="el-dropdown-link" @click="goLogin">
              欢迎您，请登录
            </div>
          </div>
        </div>
        <div class="homeTitle">
          科技成果转化双推双促工程“新动能科技成果”申报系统
        </div>
      </div> -->
      <!-- 搜索框-->
    </div>

    <div class="top-nav2" :class="{ shrinkNav: $route.meta.pickUpNav }">
      <div class="menuContent">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          text-color="#fff"
          background-color="#0366F1"
          active-text-color="#fff"
          router
          @select="handlerMenuSelect"
        >
          <el-menu-item index="/Home">首页</el-menu-item>
          <!-- <div class="scientificResearch" @click="goHomeUrl()">科基会官网</div> -->
          <!-- <el-menu-item index="/Recommendation">推介办法</el-menu-item> -->
          <el-menu-item index="/Recommending">推荐单位</el-menu-item>
          <el-menu-item index="/ExpertCommittee">专家委员会</el-menu-item>
          <el-menu-item index="/WindowOfActivity">活动之窗</el-menu-item>
          <el-menu-item index="/ProjectIntroduction">工程简介</el-menu-item>
          <div class="scientificResearch" @click="certificateInquiry()">证书查询</div>
          <div>
            <!-- @click="openInNewPage()" -->

            <el-dropdown @command="(command) => handleCommand(command)">
              <div class="scientificResearch" :class="{ 'is-active-dropdown': activeIndex === '/PastAchievements' }"> 往届活动成果 </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="item"
                  v-for="item in gameList"
                  :key="item.id"
                  >{{ item.name }}新动能科技成果</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- <el-menu-item index="/ScientificResearch">第一届新动能科技成果</el-menu-item> -->
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "Topbar",
  data() {
    return {
      gameList: [],
      hasToken: false,
      drawer: false,
      inputValue: "",
      dialogFormVisible: false, //控制显示登录dialog
      activeIndex: sessionStorage.getItem("topMenuIndex") || "/Home",
      searchVal: "",
      sub: sessionStorage.getItem("curTopbarNav") || 1,
      aboutInfo: {},
    };
  },
  mounted() {
    console.log(
      "sessionStorage.getItem",
      sessionStorage.getItem("topMenuIndex")
    );
    this.hasToken = !!sessionStorage.getItem("token");
    this.getGameList();
  },
  computed: {
    ...mapState("userAbout", ["userInfo", "isLogin"]),
  },
  created() {},
  methods: {
    certificateInquiry(){
      window.open(
        window.location.origin +
          `/#/certificateInquiry`,
        "_blank"
      );
    },
    goHomeUrl() {
      window.open("https://www.isefc.org/index.php/zh/", "_blank");
    },
    handleCommand(item) {
      sessionStorage.removeItem("targetAnchor")
      this.activeIndex = '/PastAchievements';
      sessionStorage.setItem("topMenuIndex", '/PastAchievements');
      this.$router.push({ path: "/ScientificResearch", query: { id: item.id, name: item.name } });
    },
    getGameList() {
      this.$API.getGame().then((res) => {
        this.gameList = res.data;
      });
    },
    openInNewPage() {
      // 获取当前域名和端口，拼接完整URL
      const fullUrl = window.location.origin + "/#/ScientificResearch";
      window.open(fullUrl, "_blank");
    },
    handleTableCommand(type) {
      switch (type) {
        case "oneAchievement":
          window.open(
            window.location.origin +
              "/#/ScientificResearch?type=oneAchievement",
            "_blank"
          );
          break;
        case "twoAchievement":
          window.open(
            window.location.origin +
              "/#/ScientificResearch?type=twoAchievement",
            "_blank"
          );
          break;
        case "loginOut":
          this.handleLogout();
          break;
        case "userCenter":
          const userType = this.userInfo?.type;
          if (userType === 1) {
            this.$router.push("/bgManage/projectIntroduction");
          } else if ([2, 3, 4].includes(userType)) {
            this.$router.push("/bgManage/pendingPersonal");
          } else if (userType === 5) {
            this.$router.push("/bgManage/judge/arrangeList");
          }

          break;
      }
    },

    handleLogout() {
      this.$store.dispatch("userAbout/userLogout").then(() => {
        this.$message.success("退出成功");
        this.hasToken = false;
        window.location.reload();
      });
    },
    goUrl() {
      window.open("http://stsc.isefc.org/#/isefcTop", "_blank");
    },
    goLogin() {
      this.$router.push({ path: "/Login" });
    },
    goHome() {
      this.$router.push({ path: "/Home" });
      this.handlerMenuSelectMobile("/Home");
    },
    search() {
      if (!this.inputValue) {
        this.$message.error("请输入你要搜索的内容");
        return;
      }
      this.$router.push({
        path: "/searchIndex",
        query: { keywords: this.inputValue },
      });
    },
    handleClose(done) {
      done();
    },
    showMenu() {
      this.drawer = true;
    },
    routerTo(path, sub) {
      // 路由跳转并更改小三角sub显示
      window.sessionStorage.setItem("curTopbarNav", sub);
      this.sub = sub;
      this.$router.push(path);
    },
    handlerMenuSelectMobile(index) {
      this.activeIndex = index;
      window.sessionStorage.setItem("topMenuIndex", index);
      this.drawer = false;
    },
    handlerMenuSelect(index) {
      this.activeIndex = index;
      window.sessionStorage.setItem("topMenuIndex", index);
      console.log("activeIndex==",this.activeIndex)
      console.log("sessionStorage==",window.sessionStorage.getItem("topMenuIndex"))
    },
    async querySearch(queryString, cb) {
      let ts = Date.now();
      let result = await this.$API.searchSuggest(queryString, ts);
      if (result.data.code === 200) {
        let arr = this.formatSearchResult(result.data.result);
        cb(arr);
      }
    },
    // 格式化搜索结果
    formatSearchResult(result) {
      let arr = [];
      return arr;
    },
    // 选择搜索结果后跳转到对应页面
    handleSearchSelect() {},

    logout() {
      this.$store.dispatch("userLogout");
    },
  },
};
</script>

<style scoped lang="scss">
.headTitle{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 18px;
color: #333333;

}
.headTopLogoDiv{
  display: flex;
  align-items: center;
}
.headTopLeft{
  display: flex;
  align-items: center;
  height: 100%;
}
.mt5{
  margin-top: 15px !important;
}
.headLine{
  width: 0px;
height: 20px;
border: 1px solid #B8B8B8;
margin: 0 20px;
}
.headTopRight{
  display: flex;
  align-items: center;
}
.w1230{
  width: 1200px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.headTopLogo{
  width: 303px;
  height: 73px;
}
::v-deep .el-menu--horizontal > .el-menu-item {
  height: 60px !important;
  line-height: 60px !important;
}
.logoRight {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.homeTitleContainer {
  // display: flex;
  // flex-direction: column;
  // align-items: center;
}

.homeTitle {
  font-family: Alibaba PuHuiTi 2, Alibaba PuHuiTi 20;
  font-weight: normal;
  font-size: 40px;
  color: #ffffff;
  text-align: center;
}
.el-dropdown-link {
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 16px;
color: #666666;
  cursor: pointer;
}
.containerTopContent {
  padding: 0 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 43px;
}
.containerTop {
  width: 1200px;
}
.scientificResearch {
  height: 60px;
  line-height: 60px;
  color: #fff;
  padding: 0 50px !important;
  cursor: pointer;
  font-size: 16px !important;
  &:hover {
    background: #0054c9;
  }
}
.rightHead {
  .button {
    width: 62px;
    height: 30px;
    border: 1px solid #0366f1;
    border-radius: 4px;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    color: #0366f1;
    cursor: pointer;
  }
}
.logo {
  height: 72px;
  width: 405px;
  object-fit: contain;

  margin-top: 10px;
}
.leftHead {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .line {
    width: 1px;
    height: 22px;
    background-color: #888;
    margin-left: 15px;
    margin-right: 20px;
    display: block;
  }
  .title {
    font-size: 18px;
    font-weight: 500;
    color: #333;
  }
}
.topHead {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.container {
  width: 100%;
  box-sizing: border-box;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid rgba(204, 212, 223, 0.58);
}
::v-deep .el-menu-item {
  padding: 0 50px !important;
}
::v-deep .el-menu {
  display: flex;
  justify-content: space-between;
}
::v-deep .el-menu-item {
  border-color: transparent !important;
  border-bottom: none !important;
  font-size: 16px !important;
}
::v-deep .el-menu--horizontal {
  border-bottom: none !important;
}
::v-deep .is-active {
  background: #0054c9 !important;
  border-bottom: none !important;
}
::v-deep .el-menu {
  background-color: transparent !important;
}
::v-deep .is-active-dropdown {
  background: #0054c9 !important;
}

#topbar {
  background: #fff;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.top-nav1 {

  width: 100%;
  height: 80px;
}
.top-nav2 {
  width: 100%;
  background: #0366f1;
  display: flex;
  justify-content: center;
  height: 60px;
}
.menuContent {
  width: 1200px;
}
</style>
